import { render, staticRenderFns } from "./FlexWrapBase.vue?vue&type=template&id=2eba5c92&scoped=true"
import script from "./FlexWrapBase.vue?vue&type=script&setup=true&lang=js"
export * from "./FlexWrapBase.vue?vue&type=script&setup=true&lang=js"
import style0 from "./FlexWrapBase.vue?vue&type=style&index=0&id=2eba5c92&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eba5c92",
  null
  
)

export default component.exports